import { render, staticRenderFns } from "./inbound-fax-inprogress-icon.vue?vue&type=template&id=6cf73492"
import script from "./inbound-fax-inprogress-icon.vue?vue&type=script&lang=js"
export * from "./inbound-fax-inprogress-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports